import {User} from "../types/User";
import {Report, ReportUser} from "../types/Report";

const doesUserOwnReport = (user: User | ReportUser, report: Report) => {
    return (user as User).is_admin || (report.owner !== null && report.owner === user.id);
}

export default doesUserOwnReport;